import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _EmbersMiniSelectL;
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import { PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_TEXT, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_WHITE } from '../../../../styles/colors/colors';
export var ROOT_PREFIX = 'EmbersFiltersDecorator';
export var INTER_FILTER_SPACE = 16;
export var HIDDEN_FILTER = 'hidden-filter';
export var LAST_FILTER_NO_COUNT_SPACE = 24;
export var LAST_FILTER_NO_COUNT_CLASS = 'EmbersFilterItem-lastShowFilter';
export var LAST_FILTER_COUNT_SPACE = 0;
export var LAST_FILTER_COUNT_CLASS = 'EmbersFilterItem-lastShowFilter-count';
export var FilterDecoratorContainer = styled('div')({
  flexGrow: 1
});
export var FiltersContainer = styled('div')(_defineProperty({}, "&.".concat(ROOT_PREFIX, "-container"), {
  display: 'block',
  position: 'relative',
  '& > *': {
    display: 'inline-block'
  },
  '& .EmbersMiniSelectLaunchButton-root': (_EmbersMiniSelectL = {
    alignVertical: 'top',
    marginRight: INTER_FILTER_SPACE,
    marginBottom: 16
  }, _defineProperty(_EmbersMiniSelectL, "&.".concat(HIDDEN_FILTER), {
    visibility: 'hidden'
  }), _defineProperty(_EmbersMiniSelectL, "&.".concat(LAST_FILTER_NO_COUNT_CLASS), {
    marginRight: LAST_FILTER_NO_COUNT_SPACE
  }), _defineProperty(_EmbersMiniSelectL, "&.".concat(LAST_FILTER_COUNT_CLASS), {
    marginRight: LAST_FILTER_COUNT_SPACE
  }), _EmbersMiniSelectL),
  height: 32
}));
export var MoreIcon = styled('i')(function (_ref) {
  var x = _ref.styled.x;
  return {
    position: 'absolute',
    cursor: 'pointer',
    left: x,
    top: 4,
    color: PROMETHEAN_TEXT,
    '&:focus-visible': {
      boxShadow: "inset 0px 0px 0px 2px ".concat(PROMETHEAN_BLUE)
    }
  };
});
export var StyledMobileFilterDecoratorContainer = styled('div')({});
export var StyledFilterButton = styled(Button)({
  width: 56,
  minWidth: 56,
  height: 32,
  backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
  border: "1px solid ".concat(PROMETHEAN_PURPLE_PLUM),
  borderRadius: 32,
  '&:hover': {
    background: PROMETHEAN_LIGHT_PURPLE
  },
  '&.Mui-focusVisible': {
    border: "2px solid ".concat(PROMETHEAN_BLUE),
    padding: '2px 14px',
    background: PROMETHEAN_LIGHT_PURPLE
  },
  '&.Mui-disabled': {
    color: PROMETHEAN_NEUTRAL_DARK_GREY,
    borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
    background: PROMETHEAN_NEUTRAL_WHITE,
    cursor: 'not-allowed',
    pointerEvents: 'all'
  },
  i: {
    color: PROMETHEAN_PURPLE_PLUM
  },
  '&.EmbersMobileFilterDecorator-filter-hasCount': {
    marginRight: 3
  }
});
export var StyledBadge = styled(Badge)({
  '.MuiBadge-badge': {
    top: 8,
    right: -8,
    width: 18,
    minWidth: 18,
    height: 18,
    minHeight: 18
  }
});